import React, { useState, useEffect } from 'react';
import Donate from '../donate/default';

const Resources = () => {
  const [pages, setPages] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const response = await fetch('https://ocdnewyork.org/wp/wp-json/wp/v2/pages');
      const data = await response.json();
      setPages(data);
    }

    fetchData();
  }, []);

  return (
    <div className='resources'>
     {pages.map((page) => {
        if (page.slug === 'resources') {
          return <div className='inner' dangerouslySetInnerHTML={{ __html: page.content.rendered }}></div>
        }
      })}
    </div>    
  );
}

export default Resources;